'use client'
import { usePathname, useSearchParams } from 'next/navigation'

import { useShareListViewModel } from '@/components/detail/components/shared/parkinglotShare/components/viewModel'

import type { TicketPhoto } from '@/api/dto/ticket'
import Icons from '@/shared/components/icon/Icons'
import Toast from '@/shared/components/Toast'
import { Text } from '@/shared/components/typography'
import { useInitKakaoSdk } from '@/shared/hooks/useInitKakaoSdk'

interface ShareListViewProps {
  type: string
  seq: number
  parkinglotName: string
  parkinglotAddress: string
  price?: number
  photo?: TicketPhoto
}

function ShareListView({ type, seq, parkinglotName, parkinglotAddress, price, photo }: ShareListViewProps) {
  useInitKakaoSdk()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const { states, setters, handlers } = useShareListViewModel({
    type,
    seq,
    parkinglotName,
    parkinglotAddress,
    pathname,
    searchParams,
    price,
    photo
  })

  const NAVIGATION_LIST_DATA = [
    {
      id: 1,
      name: '카카오톡으로 공유하기',
      icon: <Icons.KakaoIcon />,
      bgColor: 'bg-[#FEE500]',
      onClick: handlers.handleShareKakao
    },
    {
      id: 2,
      name: '링크 복사하기',
      icon: <Icons.CopyFillIcon fill="#B8C3D0" stroke="#F0F4F7" />,
      bgColor: 'bg-gray-020',
      onClick: handlers.handleCopyLink
    }
  ]

  const toastProps = {
    text: `${states.toastMessage}`,
    onClose: () => setters.setIsToastOpen(false)
  }

  return (
    <div className="mb-[40px] mt-[24px] w-full">
      {NAVIGATION_LIST_DATA.map(({ id, name, icon, bgColor, onClick }) => (
        <div key={id} className="flex h-[60px] w-full cursor-pointer items-center justify-between" onClick={onClick}>
          <div
            className={`flex-4 mr-[16px] flex h-[32px] w-[32px] items-center justify-center rounded-full ${bgColor}`}
          >
            {icon}
          </div>
          <Text level="text3" color="text090" weight="regular" className="flex-1 text-left">
            {name}
          </Text>
        </div>
      ))}
      {states.isToastOpen && <Toast {...toastProps} />}
    </div>
  )
}

export default ShareListView
